import React, { useEffect, useState } from "react";
import "./styles.scss"
import ConfirmationPopup from "../ConfirmationPopup";
import { firestore } from "../../Config/firebase";
import { collection, query, where, getDocs, deleteDoc, doc } from "firebase/firestore";

function RoomDetails({selectedRoom, closePopup, allReservations, selectedRoomUserData, changeAlertMakerContent,getAllReservations,showReservationForm}){

const [currentReservation,setCurrentReservation] = useState(allReservations.filter((item)=>item.room==selectedRoom)[0])
const [showConfirmationPopup,setShowConfirmationPopup] = useState(false)


useEffect(()=>{
    // console.log(currentReservation)
},[])

function convertToDateFormat(isoDateString) {
    // Create a new Date object from the ISO string
    const date = new Date(isoDateString);

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const year = date.getFullYear();

    // Return in dd/mm/yyyy format
    return `${day}-${month}-${year}`;
}


function closeConfirmationPopup(){
    setShowConfirmationPopup(false)
}

function openPopup(){
    setShowConfirmationPopup(true)
}

return(
    <div className="room-details-root">
        <div className="room-details">
        {/* <img src = "assets/cross.png" className="cross" onClick={closePopup}/> */}
        <svg viewBox="0,0,256,256" width="24px" height="24px" fill-rule="nonzero" className="cross" onClick={closePopup}><g fill="#5b2706">
                    <g transform="scale(10.66667,10.66667)">
                        <path d="M4.99023,3.99023c-0.40692,0.00011 -0.77321,0.24676 -0.92633,0.62377c-0.15312,0.37701 -0.06255,0.80921 0.22907,1.09303l6.29297,6.29297l-6.29297,6.29297c-0.26124,0.25082 -0.36647,0.62327 -0.27511,0.97371c0.09136,0.35044 0.36503,0.62411 0.71547,0.71547c0.35044,0.09136 0.72289,-0.01388 0.97371,-0.27511l6.29297,-6.29297l6.29297,6.29297c0.25082,0.26124 0.62327,0.36648 0.97371,0.27512c0.35044,-0.09136 0.62411,-0.36503 0.71547,-0.71547c0.09136,-0.35044 -0.01388,-0.72289 -0.27512,-0.97371l-6.29297,-6.29297l6.29297,-6.29297c0.29576,-0.28749 0.38469,-0.72707 0.22393,-1.10691c-0.16075,-0.37985 -0.53821,-0.62204 -0.9505,-0.60988c-0.2598,0.00774 -0.50638,0.11632 -0.6875,0.30273l-6.29297,6.29297l-6.29297,-6.29297c-0.18827,-0.19353 -0.4468,-0.30272 -0.7168,-0.30273z">
                        </path>
                    </g>
                </g>
                </svg>
        <img className="room-image" src={`https://mhreserve.com/wp-content/uploads/reserve/assets/rooms/${selectedRoomUserData.roomType}.png`}/>
        <h2 className="room-type">{currentReservation.typeOfRoom}</h2>
<div className="both-details">
        <div className="booking-details">
            {currentReservation.typeOfRoom.includes("Semi Private") && <span className="person-heading-details">Resident 1: {currentReservation.person1.name}</span>}
            {currentReservation.typeOfRoom == "Private" && <span className="person-heading-details">Resident: {currentReservation.person1.name}</span>}
            <div className="person-details">
                <div className="detail-group">
            <span>Responsible Party: {currentReservation.person1.resp}</span>
            <span>Contact Number: {currentReservation.person1.contact}</span>
            </div>
            <div className="detail-group">
            <span>Room Rate: ${currentReservation.person1.rate}</span>
            <span>Deposit: ${currentReservation.person1.deposit}</span>
            </div>
            <div className="detail-group">
            <span>Starting Date: {convertToDateFormat(currentReservation.person1.startDate)}</span>
            {currentReservation.typeOfRoom.includes("Semi Private") && <span>Bed: {currentReservation.person1.bed}</span>}
            </div>
            <div className="detail-group">
            <span>Notes: {currentReservation.person1.notes}</span>
            </div>
            </div>
        </div>

        {currentReservation.person2?.name && 
  <div className="booking-details">
  <span className="person-heading-details">Resident 2: {currentReservation.person2.name}</span>
  <div className="person-details">
  <div className="detail-group">
  <span>Responsible Party: {currentReservation.person2.resp}</span>
  <span>Contact Number: {currentReservation.person2.contact}</span>
  </div>
  <div className="detail-group">
  <span>Room Rate: ${currentReservation.person2.rate}</span>
  <span>Deposit: ${currentReservation.person2.deposit}</span>
  </div>
  <div className="detail-group">
  <span>Starting Date: {convertToDateFormat(currentReservation.person2.startDate)}</span>
  <span>Bed: {currentReservation.person2.bed}</span>
  </div>
  <div className="detail-group">
  <span>Notes: {currentReservation.person2.notes}</span>
  </div>
  </div>
</div>
}
</div>

        <div className="reserve-button" onClick={()=>{openPopup()}}>Modify Reservation</div>
</div>
{showConfirmationPopup && <ConfirmationPopup closePopup={closeConfirmationPopup} showReservationForm={showReservationForm} selectedRoom={selectedRoom}/>}
    </div>
)
}

export default RoomDetails